import { MenuItem } from "react-pro-sidebar";
import React from "react";
import useAuthority from "../../hooks/useAuthority";
import { AUTHORITY_TYPE } from "../../const";

const SideBarItem = ({
  index,
  item,
  isActive,
  isInSubMenu = false,
  form = "",
  module = "",
  children,
}) => {
  const { view } = useAuthority({
    type: AUTHORITY_TYPE.FORM,
    module: module,
    form: form,
    editMode: false,
    authenticated: true,
  });

  return (
    <MenuItem
      key={index}
      icon={<item.icon />}
      className={`sidebar-menu-item ${isActive ? "activemenu" : ""}`}
      style={
        view
          ? isActive && isInSubMenu
            ? {
                width: "95%",
                background: "#C72127",
                borderRadius: "8px",
                backdropFilter: "blur(10px)",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
              }
            : {}
          : {
              display: "none",
            }
      }
    >
      {children}
    </MenuItem>
  );
};

export default SideBarItem;
